export const DRAGGABLE_ANTIBODY_SIZE = 280;
export const DRAGGABLE_ANTIBODY_HORIZONTAL_MARGIN = 16;
export const DRAGGABLE_ANTIBODY_BOTTOM_MARGIN = 0;
export const DRAGGABLE_ANTIBODY_TOP_MARGIN = 80;
